import bootbox from "bootbox";

$(document).ready(function() {
    $("body").on("copy", ".copy-text, .show-text, [data-content-text]", function(e) {
        e.preventDefault();

        copyToClipboard(document.title + "\n" + location.href);

        bootbox.dialog({
            message: `<p class="text-center mb-0">
                   Copiado
                </p>`,
            closeButton: true,
            onEscape: true,
            backdrop: false,
            centerVertical: false,
            size: "sm",
            className: "copy-msg"
        });

        setTimeout(() => {
            bootbox.hideAll();
        }, 1500);
    });
});

function copyToClipboard(text) {
    const elem = document.createElement("textarea");
    elem.style.position = "absolute";
    elem.style.left = "-100vw";
    elem.style.bottom = "-100vh";
    elem.value = text;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand("copy");
    document.body.removeChild(elem);
}
